module.exports = __webpack_public_path__ + "static/img/examinedetailFB.0af9431.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/examinedetailFB.png
// module id = 1a/0
// module chunks = 5